module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/creditos/crediga-carburacion/detalles/components/unidad/carburacion-unidad.component.scss
// module id = ./src/app/creditos/crediga-carburacion/detalles/components/unidad/carburacion-unidad.component.scss
// module chunks = main